import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import './Login.css'

export default function Login() {
  const [key, setKey] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { login, error } = useAuth()

  async function handleSubmit(e) {
    e.preventDefault()
    if (!key.trim()) return
    
    setIsLoading(true)
    await login(key.trim())
    setIsLoading(false)
  }

  return (
    <div className="login-screen">
      <form className="login-box" onSubmit={handleSubmit}>
        <div className="login-logo">
          <span className="logo-text">TBTV</span>
          <span className="logo-vader">VADER</span>
        </div>
        <h1>Welcome Back</h1>
        <p>Enter your API key to access the admin platform</p>
        
        <input
          type="password"
          placeholder="API Key"
          value={key}
          onChange={e => setKey(e.target.value)}
          autoFocus
        />
        
        <button type="submit" disabled={isLoading || !key.trim()}>
          {isLoading ? 'Verifying...' : 'Login'}
        </button>
        
        {error && <div className="login-error">{error}</div>}
        
        <div className="login-help">
          <p className="muted">
            Contact your administrator if you need access credentials.
          </p>
        </div>
      </form>
    </div>
  )
}
